"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$Locale = void 0;
const jotai_1 = require("jotai");
exports.$Locale = (0, jotai_1.atom)({});
exports.$Locale.debugLabel = '$Locale';
